<template>
    <vx-expandable-card>
        <template v-slot:header>Invoices</template>
        <template v-slot:content>
            <div class="mt-3">
                <table class="table-auto w-full [&_td]:py-2">
                <tbody>
                    <tr v-for="invoice in props.invoices" :key="invoice.id">
                        <td>
                            <strong>{{ date(invoice.created_at) }}</strong>
                        </td>

                        <td>
                            {{ currency(invoice.total) }}
                        </td>

                        <td class="text-right">
                            <vx-button target="blank" :href="downloadUrlFor(invoice)" color="muted">
                                <font-awesome-icon widthAuto :icon="faFilePdf" /> Download PDF
                            </vx-button>
                        </td>
                    </tr>
                </tbody>
                </table>
            </div>
        </template>
    </vx-expandable-card>
</template>

<script setup>
import { currency, date } from '../../../utils/helpers';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faFilePdf } from '@fortawesome/pro-solid-svg-icons';
import { VxButton, VxExpandableCard } from '@voxie/frontend-components';

const props = defineProps({
    team: {
        type: Object,
        required: true,
    },
    invoices: {
        type: Array,
        default: () => [],
    },
});

const downloadUrlFor = (invoice) => {
    return `/settings/teams/${props.team.id}/invoice/${invoice.id}`;
};
</script>
